import styled, { css } from 'styled-components';

import theme from '$/assets/theme';

const InputContainer = styled('div')<{
  error?: boolean;
  iconPosition?: string;
  disabled?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid
    ${(props) =>
      props.error ? theme.colors.functionalRed : theme.colors.grey6};
  width: 100%;
  box-sizing: border-box;
  transition: ${(props) => props.theme.transitions.normal};
  background: ${(props) =>
    props.disabled ? props.theme.colors.grey1 : props.theme.colors.white};

  ${(props) =>
    props.iconPosition === 'end'
      ? css`
          flex-direction: row-reverse;
        `
      : null}

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.7;
    `};
`;

export default InputContainer;
